import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  width: 100%;
  padding: 30px 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
`;

const FooterLogo = styled.img`
  width: 90px;
  height: auto;
  margin-bottom: 12px;
`;

const FooterQuote = styled.p`
  font-size: 12px;
  font-style: italic;
  margin: 0 0 6px 0;
  color: #222;
`;

const FooterCopyright = styled.p`
  font-size: 10px;
  margin: 0;
  color: #555;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterLogo src="/img/logo/sleepr-studio-wink-black.png" alt="Sleepr Studio" />
      <FooterQuote>More than meets the eye.</FooterQuote>
      <FooterCopyright>Copyright 2026</FooterCopyright>
    </FooterContainer>
  );
};

export default Footer; 